import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  skillList: [],
  availableUsers: [],
  mappedUsers: [],
  message: '',
  errors: ''
};

export const manageSMESlice = createSlice({
  name: 'manageSME',
  initialState,
  reducers: {
    setManageSMELoader: (state, action) => {
      state.isLoading = action.payload;
    },
    setSkillListSME: (state, action) => {
      state.skillList = action.payload;
    },
    setUsersSME: (state, action) => {
      state.availableUsers = action.payload.nonAccessUsers ?? [];
      state.mappedUsers = action.payload.accessUsers ?? [];
    },
    setManageSMESuccessMessage: (state, action) => {
      state.message = action.payload;
    },
    setManageSMEErrorMessage: (state, action) => {
      state.errors = action.payload;
    },
    resetManageSMEMessage: (state) => {
      state.message = '';
      state.errors = '';
    }
  }
});

export const getManageSMEAction = createAction('GET_MANAGE_SME_MAPPING');
export const getSkillListSMEAction = createAction('GET_SKILL_LIST_SME');
export const saveManageSMEAction = createAction('SAVE_MANAGE_SME_MAPPING');

export const {
  setManageSMELoader,
  setSkillListSME,
  setUsersSME,
  resetManageSMEMessage,
  setManageSMEErrorMessage,
  setManageSMESuccessMessage
} = manageSMESlice.actions;

export default manageSMESlice.reducer;
